module.exports = __webpack_public_path__ + "img/9788981171247.13109be7.jpg";